'use strict';

import React from 'react/addons';

import SimpleChoice from 'ofs/components/simple-choice/SimpleChoice';


var SelectOne = React.createClass({
  propTypes: {
    options: React.PropTypes.array.isRequired,
    allowEmpty: React.PropTypes.bool,
    emptyLabel: React.PropTypes.string,
    onChange: React.PropTypes.func
  },

  render: function() {
    var {options, allowEmpty, emptyLabel} = this.props;

    options = options.map(this.renderOption);

    if (allowEmpty) {
      options.unshift(<div key="" value="">{emptyLabel}</div>);
    }

    return (
      <SimpleChoice {...this.props}>
        {options}
      </SimpleChoice>
    );
  },

  renderOption: function(option) {
    return (
      <div key={option.value + ':' + option.name} value={option.value}>
        {option.name}
      </div>
    );
  }
});

export default SelectOne;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/inputs/simple-choice.jsx
 **/